<template>
  <CModal
    :show.sync="editCalendarModal"
    :centered="true"
    title="قرار ملاقات"
    size="md"
  >
    <CForm class="edit-calendar-modal text-right">
      <CTextarea v-model="text" label="توضیحات" class="text-sm" />
    </CForm>

    <template #footer>
      <CButton
        :disabled="loading"
        @click="onEditCalendar"
        color="primary"
        class="px-5"
      >
        ثبت
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  props: {
    value: {
      type: Boolean,
    },
    calendar: {
      type: Object,
    },
  },
  data() {
    return {
      text: "",
      loading: false,
    };
  },
  computed: {
    editCalendarModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    editCalendarModal(newValue) {
      if (newValue) this.text = this.calendar.text;
    },
  },
  methods: {
    async onEditCalendar() {
      try {
        this.loading = true;
        const payload = {
          text: this.text,
        };
        await axios.put(`/calendar/${this.calendar.id}`, payload);
        this.text = "";
        this.editCalendarModal = false;
        this.$emit("get-calendar");
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
